import { Component, OnInit } from '@angular/core';
import { VirtualCardFranchiseModel } from 'src/app/shared/models/abre-cuentas.model';
import { OptionRadioModel } from 'src/app/shared/models/common.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  EVENT as EVENT_FA_TC,
  PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA,
} from 'src/app/shared/constants/dali-fa-tc.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';

const SELECTED_FRANCHISE = 'selectedFranchise';

@Component({
  selector: 'app-virtual-card-franchise',
  templateUrl: './virtual-card-franchise.component.html',
  styleUrls: ['./virtual-card-franchise.component.scss'],
})
export class VirtualCardFranchiseComponent implements OnInit {

  listProducts: OptionRadioModel[];

  enableButtonNext = false;

  virtualCardFranchiseModel: VirtualCardFranchiseModel = {
    selectedFranchise: {},
  } as VirtualCardFranchiseModel;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private abrecuentasService: AbreCuentasService,
    private bitacoraService: BitacoraService,
    private navigationService: NavigationService,
    private firmlyApprovedService: FirmlyApprovedService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private taggingService: TaggingService,
    private daliService: DaliService,
  ) {
    this.headerService.show(true, true, true);
  }

  ngOnInit() {
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendVirtualFranchisePageLoad();
    }
    this.setVirtualCardFranchiseModel();
  }

  async setVirtualCardFranchiseModel() {
    this.virtualCardFranchiseModel = await this.abrecuentasService.getVirtualCardFranchise();
    this.getListProducts();
    this.radioValidation();
  }

  /**
   * Obtiene la lista de productos para el radio options
   */
  getListProducts() {
    this.listProducts = this.abrecuentasService.getPayDayProductSelected().selectedProduct
      .map(p => ({ ...p, checked: (this.virtualCardFranchiseModel.selectedFranchise
        && p.elementId === this.virtualCardFranchiseModel.selectedFranchise.elementId) ? true : false }));
    this.listProducts.sort(p => p.elementId);
    this.listProducts.find(p => p.checked)
    ? this.enableButtonNext = true
    : this.virtualCardFranchiseModel[SELECTED_FRANCHISE] = null;
  }

  /**
   * asigna el valor del radio option seleccionado al objeto vistualCardFranchiseModel de persistencia en el flujo
   * llama a la función encargada de actualizar el servicio que controla la infromación de los radio
   * llama a la funcion encargada de validar el valor de los radio para habilitar el boton next
   * @param event
   * @param index
   */
  onRadioChange(event) {
    event.value.checked = true;
    this.virtualCardFranchiseModel[SELECTED_FRANCHISE] = event.value;
    this.updateVirtualCardFranchiseInService();
    this.radioValidation();
  }

  /**
   * Valida el objeto virtualCardfranchiseModel, para habilitar el boton next
   */
  radioValidation() {
    this.enableButtonNext = !!(this.virtualCardFranchiseModel[SELECTED_FRANCHISE]);
  }

  /**
   * Actualiza en el servicio los valores de virtualCardFranchiseModel
   */
  updateVirtualCardFranchiseInService() {
    if (this.virtualCardFranchiseModel && this.virtualCardFranchiseModel.selectedFranchise) {
      this.abrecuentasService.setVirtualCardFranchise(this.virtualCardFranchiseModel);
    }
  }

  /**
   * update selected options to global model and redirecct next view
   *
   * @memberof VirtualCardFranchiseComponent
   */
  next() {
    this.sendContinueButtonEvent();
    this.updateVirtualCardFranchiseInService();
    const bitacoraEvent = `product_datavirtualcard_${this.virtualCardFranchiseModel[SELECTED_FRANCHISE].label}`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    if (this.abrecuentasService.viewOptionMultiProduct) {
      this.navigationService.nextStep(this.navigationService.nextMulti(this.abrecuentasService.getProductsSelects()));
    } else {
      this.navigationService.nextStep();
    }
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendVirtualFranchisePageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv11pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv11pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv11pageFamily.path,
        value: PAGEVIEW_FA.pv11pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv11subFamily.path,
        value: PAGEVIEW_FA.pv11subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv11pageAction.path,
        value: PAGEVIEW_FA.pv11pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv11pageid.path,
        value: VirtualCardFranchiseComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv11transactionName.path,
        value: PAGEVIEW_FA.pv11transactionName.value,
      },
      {
        path: PAGEVIEW_FA.pv11transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv11transactionTransactionStep.value,
      },
    ];
    this.taggingService.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* -------------- Taggeo - Events ------------- */

  sendBackButtonEvent(): void {
    if (!this.taggingService.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_TC.pv11E1setData.pv11E1transactionTransactionStep.path,
        value: EVENT_FA_TC.pv11E1setData.pv11E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_TC.pv11E1setData.pv11E1transactionName.path,
        value: EVENT_FA_TC.pv11E1setData.pv11E1transactionName.value,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_TC.customCategory.module.body,
        type: EVENT_FA_TC.customCategory.type.button,
        position: EVENT_FA_TC.customCategory.position.center,
      },
      action: EVENT_FA_TC.customAction.click,
      label: EVENT_FA_TC.pv11E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendContinueButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_TC.pv11E2setData.pv11E2transactionTransactionStep.path,
        value: EVENT_FA_TC.pv11E2setData.pv11E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_TC.pv11E2setData.pv11E2transactionName.path,
        value: EVENT_FA_TC.pv11E2setData.pv11E2transactionName.value,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_TC.customCategory.module.body,
        type: EVENT_FA_TC.customCategory.type.button,
        position: EVENT_FA_TC.customCategory.position.center,
      },
      action: EVENT_FA_TC.customAction.click,
      label: EVENT_FA_TC.pv11E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }
}
